import { LockKeyhole } from "lucide-react";
import { BrandMark } from "./BrandMark";

export function HeroIntakeCard() {
  return (
    <div className="intake-card" aria-label="Example guided tax intake question">
      <div className="intake-card__meta">
        <span>STEP 4 OF 12 &middot; INCOME</span>
        <span className="text-ember">38%</span>
      </div>
      <div className="progress-track" aria-hidden="true">
        <span className="progress-fill" />
      </div>
      <div className="ai-label">
        <BrandMark compact />
        <span>Smart Intake</span>
      </div>
      <p className="intake-card__question">
        Did you receive any W&#8209;2 wages in 2025?
        <span className="typing-caret" aria-hidden="true" />
      </p>
      <p className="intake-card__hint">One question at a time. No dense forms, no scrolling.</p>
      <div className="answer-stack">
        <button className="answer-choice answer-choice--selected" type="button">
          <span>Yes, I had W&#8209;2 income</span>
          <span className="answer-choice__enter" aria-hidden="true">
            &#8629;
          </span>
        </button>
        <button className="answer-choice" type="button">
          No
        </button>
        <button className="answer-choice answer-choice--muted" type="button">
          I'm not sure
        </button>
      </div>
      <div className="intake-card__foot">
        <LockKeyhole aria-hidden="true" size={15} strokeWidth={2.2} />
        <span>HTTPS in transit and encrypted storage &middot; Your file is 38% complete</span>
      </div>
    </div>
  );
}
